import React from "react";
import { Container, Row, Col, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab, faFacebookSquare, faTwitter, faInstagram, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";
library.add(fab, faFacebookSquare, faTwitter, faInstagram, faLinkedin, faYoutube);

function Footer() {
  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 6,
      offset: 3
    },
    md: {
      span: 4,
      offset: 4
    },
    lg: {
      span: 3,
      offset: 5
    },
    xl: {
      offset: 0
    },
    className: "logo-container"
  }, /*#__PURE__*/React.createElement(Navbar.Brand, {
    href: "https://stjude.cloud"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo"
  })), /*#__PURE__*/React.createElement("a", {
    className: "sjc-title",
    href: "https://stjude.cloud"
  }, "St. Jude Cloud")), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 6
    },
    md: {
      span: 3,
      offset: 2
    },
    xl: {
      offset: 0
    },
    className: "footer-about"
  }, /*#__PURE__*/React.createElement("h6", null, "About"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud",
    title: "St. Jude Cloud Home"
  }, "Home")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://talent.stjude.org/data-sciences/jobs",
    title: "Careers"
  }, "Careers")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/privacy-policy",
    title: "Privacy Policy"
  }, "Privacy Policy")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://stjude.cloud/terms-of-use",
    title: "Terms of Use"
  }, "Terms of Use")))), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 6
    },
    md: {
      span: 3,
      offset: 2
    },
    xl: {
      offset: 0
    },
    className: "footer-apps"
  }, /*#__PURE__*/React.createElement("h6", null, "Apps"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://platform.stjude.cloud",
    title: "Genomics Platform"
  }, "Genomics Platform")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://models.stjude.cloud",
    title: "Model Systems"
  }, "Model Systems")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://pecan.stjude.cloud",
    title: "Pediatric Cancer Portal (PeCan)"
  }, "Pediatric Cancer Portal (PeCan)")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://viz.stjude.cloud",
    title: "Visualization Community"
  }, "Visualization Community")))))), /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "sub-footer"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    xl: 6,
    className: "order-last"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.stjude.org/legal/u-s-privacy-policy-statement.html",
    title: "U.S. Privacy Policy Statement"
  }, "Privacy"), " ", /*#__PURE__*/React.createElement("span", null, "\u2022")), " ", /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.stjude.org/legal.html",
    title: "Disclaimer / Registrations / Copyright Statement"
  }, "Disclaimer / Registrations / Copyright"), " ", /*#__PURE__*/React.createElement("span", null, "\u2022")), " ", /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.stjude.org/legal/linking-policy.html",
    title: "Linking Policy"
  }, "Linking"), " ", /*#__PURE__*/React.createElement("span", null, "\u2022")), " ", /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.stjude.org/legal/notice-of-privacy-practices.html",
    title: "Notice of Privacy Practices (HIPAA)"
  }, "Privacy (HIPAA)"), " ", /*#__PURE__*/React.createElement("span", null, "\u2022")), " ", /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.stjude.org/legal/notice-of-non-discrimination.html",
    title: "Notice of Non-Discrimination"
  }, "Non-Discrimination")))), /*#__PURE__*/React.createElement(Col, {
    xs: {
      span: 8,
      offset: 2
    },
    md: {
      span: 12,
      offset: 0
    },
    xl: 6
  }, /*#__PURE__*/React.createElement("p", null, "\xA9 Copyright ", new Date().getFullYear(), " St. Jude Children's Research Hospital, a not-for-profit, section 501(c)(3)."))))));
}

export default Footer;